import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import PrivateRoute from 'components/PrivateRoute';

const ExtractDataPage = Loadable(
  lazy(() => import('../pages/extra-pages/upload-document-to-database/upload-documents-to-database/UploadDocumentToDatabase'))
);
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));
const LoginPage = Loadable(lazy(() => import('../pages/extra-pages/authentication/LoginPage')));
const DataTables = Loadable(lazy(() => import('../pages/extra-pages/data-tables/DataTables')));
const PerformanceRacColumnResizing = Loadable(
  lazy(() => import('pages/extra-pages/AcsafTabels/PerformanceRac/PerformanceRacColumnResizing'))
);
const StatementNavColumnResizing = Loadable(lazy(() => import('pages/extra-pages/AcsafTabels/StatementNav/StatementNavColumnResizing')));
const BalanceSheetColumnResizing = Loadable(lazy(() => import('pages/extra-pages/AcsafTabels/BalanceSheet/BalanceSheetColumnResizing')));
const GrossPerfromanceCalcTable = Loadable(lazy(() => import('pages/extra-pages/reports/GrossPortfolioPerformance')));
const GrossPerformanceCategTable = Loadable(lazy(() => import('pages/extra-pages/reports/GrossCategoryPerformance')));
const GrossHistoricalAllocations = Loadable(lazy(() => import('pages/extra-pages/reports/GrossHistoricalAllocations')));
const GrossHistoricalAllocPercentage = Loadable(lazy(() => import('pages/extra-pages/reports/GrossHistoricalAllocPercentage')));
const HomeDashboard = Loadable(lazy(() => import('../pages/extra-pages/home-dashboard/HomeDashboard')));

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Navigate to="/login" />
    },
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/app',
      element: (
        <PrivateRoute>
          <MainLayout />
        </PrivateRoute>
      ),
      children: [
        {
          index: true,
          element: <HomeDashboard />
        },
        {
          path: 'upload-document',
          element: <ExtractDataPage />
        },
        {
          path: 'data-tables',
          element: <DataTables />
        },
        {
          path: 'performance-rac',
          element: <PerformanceRacColumnResizing />
        },
        {
          path: 'statement-nav',
          element: <StatementNavColumnResizing />
        },
        {
          path: 'balance-sheet',
          element: <BalanceSheetColumnResizing />
        },
        {
          path: 'report/gross_portfolio_performance',
          element: <GrossPerfromanceCalcTable />
        },
        {
          path: 'report/gross_category_performance',
          element: <GrossPerformanceCategTable />
        },
        {
          path: 'report/gross_historical_allocations',
          element: <GrossHistoricalAllocations />
        },
        {
          path: 'report/gross_historical_alloc_percentage',
          element: <GrossHistoricalAllocPercentage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    }
  ]
};

export default MainRoutes;
